import { render, staticRenderFns } from "./certificateInquiry.vue?vue&type=template&id=3de04098&scoped=true&"
import script from "./certificateInquiry.vue?vue&type=script&lang=js&"
export * from "./certificateInquiry.vue?vue&type=script&lang=js&"
import style0 from "./certificateInquiry.vue?vue&type=style&index=0&id=3de04098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de04098",
  null
  
)

export default component.exports